/**
 * @file applicant.tsx
 *
 * @fileoverview This is the registration page and is accessed by going to "/user/register/applicant".
 * The page displays a form for the applicant to provide his register information and on submit
 * will make a call to register the applicant.
 */
import JobiqoRegisterPage, {
  getServerSideProps,
} from '~/jobiqo/pages/user/register';
export default JobiqoRegisterPage;
export { getServerSideProps };
